module.exports = __webpack_public_path__ + "media/images/workplace/banners/uhrs_job_banner_variant7_image-e9490ccd08f7a3f7350ec153ef61a8ca.jpg";